<template>
  <div>
    <div class="dialog-box" id="gpdialog-box" @click.stop="gpcloseDialog()">
      <div class="mid-box click-show-box">
        <img
          src="../../static/mobileb/left.png"
          @click.stop="gpchangePict(-1)"
          id="gpleft-pict"
          alt=""
          class="left-pict"
        />
        <img
          src="../../static/mobileb/GP1.png"
          alt=""
          class="show-pict-big"
          id="gpshow-pict-big"
        />
        <img
          src="../../static/mobileb/right.png"
          class="right-pict"
          @click.stop="gpchangePict(1)"
          id="gpright-pict"
          alt=""
        />
      </div>
    </div>
    <div class="main">
      <div class="google-head">
        <div class="google-play-pict">
          <img src="../../static/mobileb/googleplay.png" alt="" class="pict" />
        </div>
        <div class="search-box"></div>
      </div>
      <div class="flex-start-box icon-box">
        <div class="icon-app">
          <img src="../../static/mobileb/icon.png" alt="" class="pict" />
        </div>
        <div class="app-info">
          <span class="app-name">LasVegas Slots - Win Real Cash</span>
          <span class="app-team">CipherWorks Gaming </span>
          <span class="app-ads">In-app purchases</span>
        </div>
      </div>
      <div class="flex-start-box app-data">
        <div class="app-slide-box">
          <div class="app-download">
            <span class="download-data">800K+</span>
            <span class="mark-data-grey">Downloads</span>
          </div>
          <div class="split-col"></div>
          <div class="app-review">
            <div class="star-box">
              <span class="mark-num">4.9</span>
              <img
                src="../../static/mobileb/ic_pingfen.png"
                alt=""
                class="star-single"
              />
            </div>
            <span class="mark-data-grey"
              >5k reviews
              <img
                src="../../static/mobileb/ic_gth.png"
                alt=""
                class="gth-pict gth-pict-1"
              />
            </span>
          </div>
          <div class="split-col"></div>
          <div class="app-download">
            <img
              src="../../static/mobileb/ic_xz.png"
              alt=""
              class="download-icon"
            />
            <span class="mark-data-grey mark-data-grey-1">3 MB</span>
          </div>
          <div class="split-col"></div>
          <div class="app-download">
            <img
              src="../../static/mobileb/ic_16.png"
              alt=""
              class="year-icon"
            />
            <span class="mark-data-grey"
              >Rated for 16+
              <img
                src="../../static/mobileb/ic_gth.png"
                alt=""
                class="gth-pict gth-pict-2"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="install-btn" @click.stop="download_apk()">Install</div>

      <div class="wish-share-box">
        <div class="wish-share-1">
          <img
            src="../../static/mobileb/ic_fx.png"
            alt=""
            class="share-link-pict"
          />
          <span class="wish-share-text">Share</span>
          <img
            src="../../static/mobileb/ic_qd.png"
            alt=""
            class="share-add-pict"
          />
          <span class="wish-share-text">Add to wishlist</span>
        </div>
        <div class="wish-share-1 wish-share-2">
          <img
            src="../../static/mobileb/ic_equipment.png"
            alt=""
            class="share-eq-pict"
          />
          <span class="wish-share-text-grey"
            >This app works on all your devices</span
          >
        </div>
      </div>

      <div class="flex-start-box app-show-box slider">
        <div class="show-pict-box slides">
          <img
            src="../../static/mobileb/img_1.png"
            alt=""
            class="show-pict"
            @click="gpshowDialog(1)"
          />
          <img
            src="../../static/mobileb/img_2.png"
            alt=""
            class="show-pict"
            @click="gpshowDialog(2)"
          />
          <img
            src="../../static/mobileb/img_3.png"
            alt=""
            class="show-pict"
            @click="gpshowDialog(3)"
          />
          <img
            src="../../static/mobileb/img_4.png"
            alt=""
            class="show-pict"
            @click="gpshowDialog(4)"
          />
          <img
            src="../../static/mobileb/img_1.png"
            alt=""
            class="show-pict"
            @click="gpshowDialog(1)"
          />
        </div>
      </div>

      <div class="flex-start-box about-game-box">
        <div class="about-title-arrow-box">
          <span class="about-title">About this app</span>
          <img
            src="../../static/mobileb/ic_jiantou.png"
            alt=""
            class="right-arrow-pict right-arrow-pict-margin"
          />
        </div>
        <span class="about-content">
          Step into the Dazzling World of LasVegas Slots – Where Real Money Wins
          Await!<br />
          Designed exclusively for the US market, this game brings the authentic
          Las Vegas vibe straight to your screen. With lightning-fast,
          hassle-free withdrawals, your big wins turn into real money in your
          pocket swiftly and securely. From daily bonus rounds to massive
          progressive jackpots, our game is designed to deliver generous cash
          rewards at every turn. Stunning graphics, immersive sound, and fair
          play guaranteed – this is real casino action. Play now and start
          winning today!
          <br />
          <br />
          Features: <br />
          1. Real Cash Withdrawals <br />
          2. Progressive Jackpots <br />
          3. Secure & Trusted Gameplay <br />
          4. 24/7 Dedicated Support <br />
        </span>
      </div>

      <div class="flex-change-box share-box">
        <div class="flex-change-box shard-card-box">
          <div
            class="mid-box share-card"
            v-for="shareInfo in shareInfoS"
            :key="shareInfo.pictStyle"
          >
            <img :src="shareInfo.pict" alt="" :class="shareInfo.pictStyle" />
            <div class="flex-change-box share-content-box">
              <span class="share-content">
                {{ shareInfo.content }}
              </span>
              <span class="share-content-mini">{{ shareInfo.content2 }}</span>
            </div>
          </div>
        </div>
        <span class="see-detail">See details</span>
      </div>

      <div class="flex-start-box rating-box">
        <div class="about-title-arrow-box">
          <span class="rating-title">Ratings and reviews</span>
          <img
            src="../../static/mobileb/ic_jiantou.png"
            alt=""
            class="right-arrow-pict"
          />
        </div>
        <span class="rating-mid-content">
          Ratings and reviews are verified and are from people who use the same
          type of device that you use
        </span>
        <div class="rate-card-box">
          <div class="rate-left">
            <span class="rate-num">4.9</span>
            <img
              src="../../static/mobileb/ic_pinfen.png"
              alt=""
              class="five-star-pict five-margin-rate"
            />
            <span class="rate-count">5,168</span>
          </div>
          <div class="rate-right">
            <img src="../../static/mobileb/ic_dengji.png" alt="" class="pict" />
          </div>
        </div>
      </div>

      <div class="user-box">
        <div class="user-card" v-for="user in userInfoS" :key="user.name">
          <div class="flex-start-box head-avatar-width">
            <img
              src="../../static/mobileb/ic_people.png"
              alt=""
              class="avatar"
            />
            <span class="user-name">{{ user.name }}</span>
            <img
              src="../../static/mobileb/ic_more.png"
              alt=""
              class="more-pict"
            />
          </div>
          <div class="flex-start-box user-mark-box">
            <img
              src="../../static/mobileb/ic_pinfen.png"
              alt=""
              class="five-star-pict"
            />
            <span class="user-date">{{ user.date }}</span>
          </div>
          <span class="flex-start-box user-content">
            {{ user.content }}
          </span>
          <div class="flex-start-box last-avatar-box">
            <span class="user-help-span">Was this review helpful?</span>
            <div class="mid-box button-box-total">
              <div class="mid-box yes-button">Yes</div>
              <div class="mid-box yes-button">No</div>
            </div>
          </div>
        </div>
        <span class="see-reviews">See all reviews</span>
        <div class="line-reviews"></div>
      </div>

      <div class="google-policy-box google-policy-box-1">
        <span class="policy-title">Google Play</span>
        <span class="policy-span">Play Pass</span>
        <span class="policy-span">Play Points</span>
        <span class="policy-span">Gift cards</span>
        <span class="policy-span">Redeem</span>
        <span class="policy-span">Refund policy</span>
      </div>
      <div class="google-policy-box google-policy-box-2">
        <span class="policy-title">Children and family</span>
        <span class="policy-span">Parent guide</span>
        <span class="policy-span">Family sharing</span>
      </div>

      <div class="terms-box">
        <span>Terms of service</span>
        <span>Privacy</span>
        <span>About Google Play</span>
        <span>Developers</span>
        <span>Google Store</span>
        <span>All prices include VAT.</span>
      </div>

      <div class="flag-box">
        <img
          src="../../static/mobileb/ic_American.png"
          alt=""
          class="india-pict"
        />
        <span class="flag-text">English (United States)</span>
      </div>
    </div>
    <div class="app-bottom">
      <div class="app-bottom-card-box">
        <div
          class="bottom-card"
          v-for="bottomInfo in bottomInfoS"
          :key="bottomInfo.index"
        >
          <img :src="bottomInfo.pict" alt="" :class="bottomInfo.pictStyle" />
          <span class="bottom-card-title">{{ bottomInfo.title }}</span>
        </div>
      </div>
    </div>
    <!-- tg box -->
    <!-- <div class="tg_reward_box" @click.stop="closeTgRewardBox" id="tgReward">
      <div
        class="tg_reward_container"
        @click.stop="tgOpen('tgch_click_view_laybackscene')"
      >
        <div class="tg_reward_top">
          <img
            src="../../static/mobileb/ic_reward.png"
            alt=""
            class="reward_logo"
          />
          <div>We sincerely look forward to your subscribe.</div>
        </div>
        <div class="bg_happy">
          <img
            src="../../static/mobileb/tg_ICON.png"
            alt=""
            class="happy_icon"
          />
          <div class="happy_datas">
            <div class="title">Happy Ace Casino</div>
            <ul>
              <li>Official Channel for Happy Ace Casino</li>
              <li>Get Freecash Gift Code</li>
              <li>Trusted by 6cr+ players.</li>
            </ul>
          </div>
        </div>
        <div class="join_box">
          <img src="../../static/mobileb/ic_join.png" alt="" class="ic_join" />
          <div>
            Join our official telegram channel for the latest Gift Code
            giveaways, updates, and exclusive promotions.
          </div>
        </div>
        <div class="join_btn">
          <img
            src="../../static/mobileb/btn_join.png"
            alt=""
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { download, chnup, loadPage } from "../utils/tools";

export default {
  data() {
    return {
      userInfoS: [
        {
          name: "Kellan Vance",
          date: "1/5/26",
          content:
            "Finally, a real-money slots app that truly delivers! The cash-outs are instant and the jackpots feel endless. Pure Vegas magic!",
        },
        {
          name: "Jessa Marlowe",
          date: "1/3/26",
          content:
            "Graphics and sounds transport you straight to the Strip. Plus, the cash rewards are real and frequent. 5 stars!",
        },
        {
          name: "Evan Thorne",
          date: "1/2/26",
          content:
            "Secure, fair, and incredibly rewarding. As a player, I appreciate the tailored themes and instant withdrawals. Top-tier app!",
        },
      ],
      shareInfoS: [
        {
          pict: require("../../static/mobileb/ic_lianjie.png"),
          pictStyle: "share-pict-1",
          content: "This app may share these data types with third parties",
          content2: "App activity and Device or other IDs",
        },
        {
          pict: require("../../static/mobileb/ic_yun.png"),
          pictStyle: "share-pict-2",
          content: "This app may collect these data",
          content2:
            "App activity,App info and performance.and Device or other IDs",
        },
        {
          pict: require("../../static/mobileb/ic_lock.png"),
          pictStyle: "share-pict-3",
          content: "Data is encrypted in transit",
        },
        {
          pict: require("../../static/mobileb/ic_ljt.png"),
          pictStyle: "share-pict-4",
          content: "You can request that data be deleted",
        },
      ],
      bottomInfoS: [
        {
          index: 1,
          pict: require("../../static/mobileb/ic_Games.png"),
          pictStyle: "bottom-pict-1",
          title: "Games",
        },
        {
          index: 2,
          pict: require("../../static/mobileb/ic_Apps.png"),
          pictStyle: "bottom-pict-2",
          title: "Apps",
        },
        {
          index: 3,
          pict: require("../../static/mobileb/ic_Movies&TV.png"),
          pictStyle: "bottom-pict-3",
          title: "Movies & TV",
        },
        {
          index: 4,
          pict: require("../../static/mobileb/ic_Books.png"),
          pictStyle: "bottom-pict-4",
          title: "Books",
        },
        {
          index: 5,
          pict: require("../../static/mobileb/ic_Children.png"),
          pictStyle: "bottom-pict-5",
          title: "Children",
        },
      ],
    };
  },
  methods: {
    download_apk: function (event) {
      chnup("click");
      download();
      // this.showTgReward();
    },
    showTgReward() {
      setTimeout(() => {
        var element = document.getElementById("tgReward");
        element.classList.remove("tg_reward_box_hidden");
        element.classList.add("tg_reward_box_show");
      }, 8000);
    },
    closeTgRewardBox() {
      var element = document.getElementById("tgReward");
      element.classList.remove("tg_reward_box_show");
      element.classList.add("tg_reward_box_hidden");
    },
    gpchangePict: function (msg) {
      let changeIndex = this.nowPict + msg;
      if (changeIndex <= 0) {
        let leftDiv = document.getElementById("gpleft-pict");
        leftDiv.style.visibility = "hidden";
        return;
      } else if (changeIndex > 4) {
        let rightDiv = document.getElementById("gpright-pict");
        rightDiv.style.visibility = "hidden";
        return;
      } else {
        this.nowPict = changeIndex;
        let leftDiv = document.getElementById("gpleft-pict");
        leftDiv.style.visibility = "visible";
        let rightDiv = document.getElementById("gpright-pict");
        rightDiv.style.visibility = "visible";
        if (changeIndex == 4) {
          let rightDiv = document.getElementById("gpright-pict");
          rightDiv.style.visibility = "hidden";
        }
        if (changeIndex == 1) {
          let leftDiv = document.getElementById("gpleft-pict");
          leftDiv.style.visibility = "hidden";
        }
        let imgDiv = document.getElementById("gpshow-pict-big");
        imgDiv.src = `../../static/mobileb/GP${changeIndex}.png`;
      }
    },
    gpshowDialog: function (id) {
      chnup(`click_v${id + 1}`);
      let leftDiv = document.getElementById("gpleft-pict");
      leftDiv.style.visibility = "visible";
      let rightDiv = document.getElementById("gpright-pict");
      rightDiv.style.visibility = "visible";
      let dialogDiv = document.getElementById("gpdialog-box");
      dialogDiv.style.display = "block";
      this.nowPict = id;
      if (this.nowPict == 1) {
        let leftDiv = document.getElementById("gpleft-pict");
        leftDiv.style.visibility = "hidden";
      }
      if (this.nowPict == 4) {
        let rightDiv = document.getElementById("gpright-pict");
        rightDiv.style.visibility = "hidden";
      }
      let imgDiv = document.getElementById("gpshow-pict-big");
      imgDiv.src = `../../static/mobileb/GP${id}.png`;
    },
    gpcloseDialog: function () {
      let dialogDiv = document.getElementById("gpdialog-box");
      dialogDiv.style.display = "none";
    },
    autoPlay() {
      let currentIndex = 0;
      console.log(1);
      let interval = setInterval(nextSlide, 3000);

      function nextSlide() {
        const slides = document.getElementsByClassName("show-pict");
        const totalSlides = slides.length;
        const slideWidth = slides[0].clientWidth;
        const slider = document.querySelector(".slides");

        currentIndex++;
        if (currentIndex >= totalSlides - 1) {
          currentIndex = 0;
        }
        slider.style.transform = `translateX(-${currentIndex * 91.63}vw)`;
      }
    },
  },
  created() {},
  mounted() {
    // script.js
    this.autoPlay();
  },
};
</script>

<style lang="less" scoped>
.slides {
  display: flex; /* 使用flex布局 */

  width: 89.03vw;
  transition: transform 0.5s ease; /* 平滑过渡效果 */
}
.slider {
  width: 95vw; /* 根据需要调整宽度 */
  overflow: hidden; /* 隐藏超出部分 */
  position: relative; /* 相对定位 */
}
.main {
  background: #ffffff;
  height: auto;
  box-sizing: border-box;
  padding: 2.8vw 0vw;
  padding-right: 0vw;
  font-family: "rb";
  padding-bottom: 20vw;
}
.flex-start-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.play-pict {
  width: 36.27vw;
  height: 8.27vw;
}
.search-pict {
  width: 4.13vw;
  height: 4.27vw;
  margin-left: 17.07vw;
  margin-right: 4.86vw;
}
.question-pict {
  width: 4.67vw;
  height: 4.8vw;
}
.icon-box {
  margin-left: 4.86vw;
  margin-top: 7.73vw;
  justify-content: flex-start;
  align-items: flex-start;
}
.icon-app {
  width: 20.13vw;
  height: 19.2vw;
}
.app-info {
  display: flex;
  flex-direction: column;
  margin-left: 6.13vw;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20vw;
}
.app-name {
  font-size: 5vw;
  line-height: 4.4vw;
  color: #333333;
  margin-top: 1vw;
}
.app-team {
  font-size: 4vw;
  line-height: 5.84vw;
  color: #0957bc;
  margin-top: 2.13vw;
}
.app-ads {
  font-size: 3.2vw;
  line-height: 5.84vw;
  color: #666666;
}
.app-data {
  margin-top: 7.92vw;
  margin-left: 1.86vw;
}
.app-slide-box {
  width: 96.28vw;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: auto;
  scrollbar-width: none;
}
.app-review {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 32.22vw;
}
.star-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mark-num {
  font-size: 4vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 5.6vw;
  letter-spacing: 0vw;
  color: #000000;
}
.star-single {
  width: 2.13vw;
  height: 2vw;
  margin-left: 1.33vw;
}
.mark-data-grey {
  font-size: 3.2vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vw;
  color: #666666;
  width: 26vw;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}
.mark-data-grey-1 {
  width: 20vw;
}
.app-download {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 21.67vw;
}
.download-data {
  font-size: 4vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 5.6vw;
  letter-spacing: 0vw;
  color: #333333;
}
.install-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90.42vw;
  height: 10.67vw;
  background-color: #0b57cf;
  border-radius: 5.33vw;
  margin-top: 4.93vw;
  margin-left: 4.72vw;
  font-size: 4vw;
  color: #ffffff;
}
.app-show-box {
  margin-top: 5.64vw;
  margin-left: 4.86vw;
}
.show-pict-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  /* overflow: auto; */
  scrollbar-width: none;
}
::-webkit-scrollbar {
  display: none;
}
.show-pict {
  width: 89.03vw;
  height: auto;
  margin-left: 2.53vw;
}
.show-pict:nth-child(1) {
  margin-left: 0vw;
}
.show-pict:last-child {
  margin-right: 4.86vw;
}
.about-game-box {
  margin-top: 7.73vw;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-left: 4.86vw;
}
.about-title {
  font-size: 4.8vw;
  line-height: 5.84vw;
  color: #333333;
  margin-bottom: 4.8vw;
}
.about-content {
  width: 90.28vw;
  font-size: 3.2vw;
  line-height: 4.4vw;
  color: #666666;
}
.collapse-span {
  font-size: 3.2vw;
  color: #17ac3c;
  margin-top: 11.33vw;
  width: 90.28vw;
  text-align: center;
}
.rating-box {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 10.13vw;
  margin-left: 4.86vw;
}
.rating-title {
  font-size: 4.8vw;
  color: #333333;
}
.rate-card-box {
  width: 90.28vw;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  margin-top: 8.13vw;
}
.rate-left {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  height: 27vw;
  align-items: center;
}
.rate-right {
  width: 62.92vw;
  height: auto;
  position: relative;
  left: 10.14vw;
}
.rate-num {
  font-size: 12.8vw;
  color: #333333;
  line-height: 1;
  font-family: "dm";
}
.five-star-pict {
  width: 13.2vw;
  height: 2vw;
}
.five-margin-rate {
  margin-top: 4.32vw;
}
.rate-count {
  font-size: 3.2vw;
  color: #666;
  margin-top: 1.33vw;
}
.user-box {
  margin-top: 11.07vw;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 4.86vw;
}
.user-card {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 6.25vw;
}
.user-card:nth-child(3) {
  margin-bottom: 11.47vw;
}
.avatar {
  width: 8.93vw;
  height: 9.07vw;
}
.user-name {
  font-size: 3.73vw;
  color: #262323;
  margin-left: 4.67vw;
}
.user-mark-box {
  margin-top: 1.07vw;
}
.user-date {
  font-size: 3.73vw;
  color: #676769;
  margin-left: 2.67vw;
}
.user-content {
  margin-top: 3.87vw;
  font-size: 3.73vw;
  color: #676769;
  width: 83.33vw;
}
.split-col {
  height: 6vw;
  border-left: solid 0.13vw #666;
  margin: 0 3vw;
}
.gth-pict {
  width: 2.67vw;
  height: 2.67vw;
}
.gth-pict-1 {
  margin-left: 4vw;
}
.gth-pict-2 {
  margin-left: 1.2vw;
}
.download-icon {
  width: 4.93vw;
  height: 4.93vw;
  margin-bottom: 1vw;
}
.year-icon {
  width: 5.33vw;
  height: 3.73vw;
  margin-bottom: 2.19vw;
}
.right-arrow-pict {
  width: 4.13vw;
  height: 4.13vw;
  transform: rotate(180deg);
}
.right-arrow-pict-margin {
  margin-bottom: 4.8vw;
}
.about-title-arrow-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90.28vw;
}
.share-box {
  width: 90.28vw;
  height: 81.6vw;
  border-radius: 2.4vw;
  border: solid 0.27vw #acaba9;
  margin-top: 5.94vw;
  margin-left: 4.86vw;
}
.shard-card-box {
  justify-content: space-between;
  height: 54.03vw;
}
.share-card {
  width: 72.54vw;
  justify-content: space-between;
  align-items: flex-start;
}
.share-pict-1 {
  width: 4.8vw;
  height: 4.93vw;
  margin-top: 1vw;
}
.share-pict-2 {
  width: 5.47vw;
  height: 4vw;
}
.share-pict-3 {
  width: 4.13vw;
  height: 5.47vw;
  margin-top: -1vw;
  position: relative;
  left: 0.5vw;
}
.share-pict-4 {
  width: 4.27vw;
  height: 4.53vw;
  margin-top: -1vw;
  position: relative;
  left: 0.5vw;
}
.share-content {
  width: 64.13vw;
  font-size: 3.47vw;
  line-height: 4.34vw;
  color: #666;
}
.see-detail {
  width: 72.54vw;
  text-align: left;
  margin-top: 9vw;
  font-size: 3.47vw;
  color: #0b57cf;
  font-weight: bold;
}
.rating-mid-content {
  width: 92.28vw;
  font-size: 3.06vw;
  color: #666;
  margin-top: 8vw;
}
.head-avatar-width {
  width: 87.64vw;
  align-items: center;
}
.more-pict {
  width: 0.93vw;
  height: 4.13vw;
  margin-left: auto;
}
.last-avatar-box {
  margin-top: 7.87vw;
  width: 90.28vw;
}
.user-help-span {
  font-size: 2.93vw;
  color: #676769;
}
.button-box-total {
  margin-left: auto;
  width: 28.54vw;
  justify-content: space-between;
}
.yes-button {
  width: 13.07vw;
  height: 8vw;
  font-size: 3.73vw;
  border: 1px solid#676769;
  border-radius: 8px;
}
.share-content-box {
  justify-content: flex-start;
  align-items: flex-start;
}
.share-content-mini {
  font-size: 2.93vw;
  color: #666;
  margin-top: 1.27vw;
  width: 64.13vw;
}
.google-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 14.67vw;
  margin-left: 4.86vw;
}
.google-play-pict {
  width: 32vw;
  height: 7.47vw;
}
.search-box {
  width: 23.61vw;
  height: 7.36vw;
  margin-left: 35.67vw;
  background-image: url("../../static/mobileb/ic_top.png");
  background-size: cover;
}
.question-box {
  width: 4.27vw;
  height: 4.27vw;
  margin-left: 4.93vw;
}
.wish-share-box {
  height: 9.56vw;
  width: 86.8vw;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 3.47vw;
  margin-left: 4.86vw;
  gap: 0.62vw;
}
.wish-share-1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.share-link-pict {
  width: 2.53vw;
  height: 2.53vw;
}
.wish-share-text {
  font-family: "rb";
  font-size: 3.2vw;
  color: #0b57cf;
  margin-left: 0.8vw;
}
.wish-share-text-grey {
  font-family: "rb";
  font-size: 3.2vw;
  color: #5f6368;
  margin-left: 0.8vw;
}
.share-add-pict {
  width: 2vw;
  height: 2.67vw;
  margin-left: 2.4vw;
}
.share-eq-pict {
  width: 2.93vw;
  height: 2.27vw;
}
.see-reviews {
  width: 72.54vw;
  text-align: left;
  font-size: 3.47vw;
  color: #0b57cf;
  font-weight: bold;
  position: relative;
  top: -7.2vw;
}
.line-reviews {
  width: 90.56vw;
  border-bottom: solid 0.13vw #eeeeee;
}
.google-policy-box {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.google-policy-box-1 {
  margin-top: 10.27vw;
  margin-left: 4.86vw;
}
.google-policy-box-2 {
  margin-top: 8.27vw;
  margin-left: 4.86vw;
}
.policy-title {
  font-size: 2.67vw;
  font-weight: bold;
  color: #000;
}
.policy-span {
  font-size: 2.67vw;
  color: #5f6368;
  margin-top: 3.87vw;
}
.terms-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 56.53vw;
  height: 12.8vw;
  font-size: 2.4vw;
  color: #5f6368;
  flex-wrap: wrap;
  margin-top: 8vw;
  margin-left: 4.86vw;
}
.flag-box {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 4.67vw;
  margin-left: 4.86vw;
}
.india-pict {
  width: 2.93vw;
  height: 2vw;
}
.flag-text {
  font-size: 2.4vw;
  color: #5f6368;
  margin-left: 1.47vw;
}
.app-bottom {
  width: 100vw;
  height: 13.46vw;
  border-top: solid 0.27vw #dcdcdc;
  margin-top: 6.67vw;

  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: fixed;
  z-index: 200;
  bottom: 0;
  background-color: #fff;
}
.app-bottom-card-box {
  width: 90vw;

  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  top: 0.5vw;
}
.bottom-card {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  height: 8vw;
}
.bottom-pict-1 {
  width: 4.13vw;
  height: 3.2vw;
}
.bottom-pict-2 {
  width: 3.33vw;
  height: 3.47vw;
}
.bottom-pict-3 {
  width: 3.6vw;
  height: 4vw;
}
.bottom-pict-4 {
  width: 3.2vw;
  height: 4.13vw;
}
.bottom-pict-5 {
  width: 4.53vw;
  height: 4.4vw;
}
.bottom-card-title {
  font-size: 2.93vw;
  color: #5f6368;
}
.bottom-card:nth-child(1) span {
  color: #0b57cf;
}
.dialog-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 500;
}
.click-show-box {
  width: 100vw;
  margin-top: 20vw;
}
.show-pict-big {
  width: 79.2vw;
  height: auto;
}
.left-pict {
  width: 13.47vw;
  height: 13.47vw;
  position: relative;
  left: 9.47vw;
  z-index: 200;
}
.right-pict {
  width: 13.47vw;
  height: 13.47vw;
  position: relative;
  right: 9.47vw;
  z-index: 200;
}
.tg_reward_box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 302;
  top: 0;
  opacity: 0;
  transform: translateY(100%);
}
.tg_reward_box_show {
  animation: fadeIn 1s forwards;
}
@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
    transform: translateY(100%);
  }
}
.tg_reward_box_hidden {
  opacity: 1;
  transform: translateY(0);
  animation: fadeOut 1s forwards;
}

.tg_reward_container {
  width: 95vw;
  height: 71.25vw;
  background-color: #ffffff;
  border-radius: 4.17vw;
  position: absolute;
  top: 38.19vw;
  left: 2.5vw;
}
.tg_reward_top {
  font-family: ArialMT;
  font-size: 2.5vw;
  line-height: 6.67vw;
  letter-spacing: 0vw;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3.06vw;
  margin-bottom: 1vw;
}
.reward_logo {
  width: 24.17vw;
  height: 10vw;
}
.bg_happy {
  width: 86.12vw;
  height: 17.77vw;
  width: 90.56vw;
  height: 23.89vw;
  background-color: #ffffff;
  box-shadow: 0vw 0vw 1.94vw 0vw rgba(23, 7, 43, 0.3);
  border-radius: 2.78vw;
  margin: auto;
  display: flex;
  /* padding: 3.06vw 2.22vw; */
}
.happy_icon {
  width: 14.86vw;
  height: 15vw;
  margin-right: 1.94vw;
  margin: 4.86vw 1.94vw 0 2.22vw;
}
.happy_datas {
  margin-top: 2.04vw;
}
.happy_datas .title {
  font-family: Arial-BoldMT;
  font-size: 4.17vw;
  color: #000000;
  font-weight: bold;
}
.happy_datas ul {
  margin: 0;
  padding-inline-start: 4vw;
  line-height: 4.25vw;
  margin-top: 0.29vw;
}
.happy_datas ul li {
  font-family: ArialMT;
  font-size: 2.5vw;
  color: #333333;
  letter-spacing: 0.07vw;
}
.happy_datas ul li::marker {
  width: 1.25vw;
  height: 1.25vw;
  background-color: #333333;
}
.join_box {
  display: flex;
  font-family: ArialMT;
  font-size: 2.22vw;
  color: #000000;
  align-items: center;
  margin-top: 2.22vw;
  margin-bottom: 2.36vw;
}
.ic_join {
  width: 14.86vw;
  height: 11.39vw;
  margin-left: 4.44vw;
  margin-right: 1.39vw;
}
.join_btn {
  width: 86.81vw;
  height: 6.11vw;
  margin: auto;
}
.dialog-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 249;
}
.click-show-box {
  width: 100vw;
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
}
.show-pict-big {
  width: 90.2vw;
  height: auto;
}
.left-pict {
  width: 8.47vw;
  height: 8.47vw;
  position: relative;
  left: 5.47vw;
  z-index: 200;
}
.right-pict {
  width: 8.47vw;
  height: 8.47vw;
  position: relative;
  right: 5.47vw;
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/components/pageB.vue